import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IAppState } from './app.state';

export const selectAppState = createFeatureSelector<IAppState>('app')
export const selectApp = createSelector(selectAppState, (state) => state);
export const selectLanguage = createSelector(selectAppState, (state) => state.language);
export const selectTheme = createSelector(selectAppState, (state) => state.theme);